import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import RoleForm from "@/admin/components/settings/roles/RoleForm";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/roles/create",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "core.role.create");

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  const { t } = useTranslation("core.shared");

  return (
    <Container
      title={t("Create Role")}
      description={t("Create and edit roles")}
    >
      <RoleForm />
    </Container>
  );
}
